var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWebLoginString({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 612,
    height: 102,
    viewBox: "0 0 612 102",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-1 54.2762C25.0883 74.3053 92.5138 110.958 153.51 97.3387C229.755 80.314 337.306 1.69995 416.581 1.69995C495.855 1.69995 574.625 97.3387 613 97.3387",
    stroke: "white",
    strokeOpacity: 0.4,
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebLoginString);
export default __webpack_public_path__ + "static/media/web-login-string.d65542efd2136007120ec9c829fe05a0.svg";
export { ForwardRef as ReactComponent };